export { default } from "./pagination-numbers";
